export const SUMMARY_ERROR_SET = 'SUMMARY_ERROR_SET'
export const SUMMARY_LOADING_SET = 'SUMMARY_LOADING_SET'
export const SUMMARY_SET = 'SUMMARY_SET'